module.exports = __webpack_public_path__ + "static/media/mqtt_protocol_en.d96cd24d.md";